'use client'
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/context/useQueue.ts
import { useContext, useEffect } from "react";

// src/context/context.tsx
import { createContext } from "react";
var defaultQueueState = {
  isActive: false,
  shouldWaitQueue: false,
  queue: void 0,
  slug: void 0,
  autoRefresh: false,
  canJumpQueue: false,
  initQueue: () => __async(void 0, null, function* () {
  }),
  setAutoRefresh: () => {
  }
};
var QueueContext = createContext(defaultQueueState);
var context_default = QueueContext;

// src/context/useQueue.ts
var useQueue = (options) => {
  const context = useContext(context_default);
  if (!context)
    throw new Error("useQueue must be used within QueueProvider");
  useEffect(() => {
    var _a;
    if ((options == null ? void 0 : options.autoRefresh) !== void 0) {
      (_a = context.setAutoRefresh) == null ? void 0 : _a.call(context, options.autoRefresh);
    }
  }, [options == null ? void 0 : options.autoRefresh]);
  return context;
};
var useQueue_default = useQueue;

export {
  __async,
  context_default,
  useQueue_default
};
//# sourceMappingURL=chunk-HQFDKIJY.mjs.map